export const PRIMARY_TABS = [
  { label: 'ダッシュボード', href: '/dashboard' },
  { label: '進捗入力', href: '/dashboard/progress-management' },
];

export const DASHBOARD_TABS = [
  { label: '進捗状況（地域別）', href: '/dashboard' },
  { label: '進捗報告', href: '/dashboard/region-progress-report' },
  { label: 'スケジュール一覧', href: '/dashboard/schedule-list' },
  { label: '課題リスク（地域別）', href: '/dashboard/region-risk' },
  { label: '課題リスク（プロジェクト別）', href: '/dashboard/project-risk' },
  { label: '課題リスク統計', href: '/dashboard/risk-stats' },
];

export const INPUT_TABS = [
  { label: '進捗管理', href: '/dashboard/progress-management' },
  { label: '進捗報告', href: '/dashboard/progress-report' },
  { label: 'リスク管理', href: '/dashboard/risk-management' },
  { label: '課題管理', href: '/dashboard/problem-management' },
  { label: '成果物管理', href: '/dashboard/deliverable-management' },
  { label: 'AI管理', href: '/dashboard/ai-management' },
];
